import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import i18n from "i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

i18n.addResourceBundle("en", "translation", en);
i18n.addResourceBundle("ar", "translation", ar);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
